import React from 'react';
import Header from '../components/Header';

const ContactHero = () => {
  return (
    <section 
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
      style={{
       backgroundImage: 'url(https://empirelimotransfer.com/wp-content/uploads/elementor/thumbs/Quality-and-Comfort-in-Black-Car-Services-rfbp7tg55qeyb9siklds8nx4852mhwtastvj8qkxq0.png)',
      }}
    >
      <Header/>

      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
        <div className="max-w-5xl text-center text-white">
          <h1 className="font-bold leading-snug text-white">
            Contact Us
          </h1>
          <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
            <a href="/" className="hover:text-logo-green">Home</a>
            <span>-</span>
            <span className="text-logo-green">Contact Us</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
